import { postAccountsApi } from "../../../../../shared/utils/ajax";
export const unsubscribe = payload => {
  return postAccountsApi(payload, "/remarketing/unsubscribe");
};